export var ErrorType;
(function (ErrorType) {
    /** Error is unknown or not suitable for any of options bellow */
    ErrorType["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
    /** Type of submitted value is incorrect */
    ErrorType["TYPE_ERROR"] = "TYPE_ERROR";
    /** Value is required to be provided */
    ErrorType["REQUIRED_VALUE_ERROR"] = "REQUIRED_VALUE_ERROR";
    /** Value contains additional properties not expected in schema */
    ErrorType["UNKNOWN_VALUE_ERROR"] = "UNKNOWN_VALUE_ERROR";
    /** Text value exceeds max length */
    ErrorType["MAX_LENGTH_ERROR"] = "MAX_LENGTH_ERROR";
    /** Text value not reaches min length */
    ErrorType["MIN_LENGTH_ERROR"] = "MIN_LENGTH_ERROR";
    /** Text value not applicable for expected pattern */
    ErrorType["PATTERN_ERROR"] = "PATTERN_ERROR";
    /** Text value not applicable for expected format */
    ErrorType["FORMAT_ERROR"] = "FORMAT_ERROR";
    /** Number value is too big */
    ErrorType["MAX_VALUE_ERROR"] = "MAX_VALUE_ERROR";
    /** Number value is too small */
    ErrorType["MIN_VALUE_ERROR"] = "MIN_VALUE_ERROR";
    /** Number value is not multiple of expected number */
    ErrorType["MULTIPLE_OF_VALUE_ERROR"] = "MULTIPLE_OF_VALUE_ERROR";
    /** Array value has too much items */
    ErrorType["MIN_ITEMS_ERROR"] = "MIN_ITEMS_ERROR";
    /** Array value has not enough items */
    ErrorType["MAX_ITEMS_ERROR"] = "MAX_ITEMS_ERROR";
    /** Value is not in list of allowed values */
    ErrorType["NOT_ALLOWED_VALUE_ERROR"] = "NOT_ALLOWED_VALUE_ERROR";
    /** Form fields are incompatible */
    ErrorType["FIELDS_COMPATIBILITY_ERROR"] = "FIELDS_COMPATIBILITY_ERROR";
    /** Submitted form is disabled */
    ErrorType["DISABLED_FORM_ERROR"] = "DISABLED_FORM_ERROR";
    /** Too much forms */
    ErrorType["FORMS_COUNT_RESTRICTIONS_ERROR"] = "FORMS_COUNT_RESTRICTIONS_ERROR";
    /** Too much fields on form */
    ErrorType["FIELDS_COUNT_RESTRICTIONS_ERROR"] = "FIELDS_COUNT_RESTRICTIONS_ERROR";
    /** Too much steps on forms */
    ErrorType["STEPS_COUNT_RESTRICTIONS_ERROR"] = "STEPS_COUNT_RESTRICTIONS_ERROR";
    /** Too much rules on forms */
    ErrorType["RULES_COUNT_RESTRICTIONS_ERROR"] = "RULES_COUNT_RESTRICTIONS_ERROR";
    /** File upload is not allowed */
    ErrorType["FILE_UPLOAD_RESTRICTIONS_ERROR"] = "FILE_UPLOAD_RESTRICTIONS_ERROR";
})(ErrorType || (ErrorType = {}));
export var RequiredIndicator;
(function (RequiredIndicator) {
    RequiredIndicator["UNKNOWN_INDICATOR"] = "UNKNOWN_INDICATOR";
    /** Asterisk (*). */
    RequiredIndicator["ASTERISK"] = "ASTERISK";
    /** Text (default: "Required"). */
    RequiredIndicator["TEXT"] = "TEXT";
    /** None. */
    RequiredIndicator["NONE"] = "NONE";
})(RequiredIndicator || (RequiredIndicator = {}));
export var RequiredIndicatorPlacement;
(function (RequiredIndicatorPlacement) {
    RequiredIndicatorPlacement["UNKNOWN_PLACEMENT"] = "UNKNOWN_PLACEMENT";
    /** After field title. */
    RequiredIndicatorPlacement["AFTER_FIELD_TITLE"] = "AFTER_FIELD_TITLE";
    /** Before field title. */
    RequiredIndicatorPlacement["BEFORE_FIELD_TITLE"] = "BEFORE_FIELD_TITLE";
})(RequiredIndicatorPlacement || (RequiredIndicatorPlacement = {}));
export var Format;
(function (Format) {
    Format["UNDEFINED"] = "UNDEFINED";
    Format["DATE"] = "DATE";
    Format["TIME"] = "TIME";
    Format["DATE_TIME"] = "DATE_TIME";
    Format["EMAIL"] = "EMAIL";
    Format["URL"] = "URL";
    Format["UUID"] = "UUID";
    Format["PHONE"] = "PHONE";
    Format["URI"] = "URI";
    Format["HOSTNAME"] = "HOSTNAME";
    Format["COLOR_HEX"] = "COLOR_HEX";
    Format["CURRENCY"] = "CURRENCY";
    Format["LANGUAGE"] = "LANGUAGE";
    Format["DATE_OPTIONAL_TIME"] = "DATE_OPTIONAL_TIME";
})(Format || (Format = {}));
export var ValidationFormat;
(function (ValidationFormat) {
    ValidationFormat["UNDEFINED"] = "UNDEFINED";
    /** File upload validation. */
    ValidationFormat["WIX_FILE"] = "WIX_FILE";
    /** Payment validation. */
    ValidationFormat["PAYMENT"] = "PAYMENT";
    /** Multiline address. */
    ValidationFormat["MULTILINE_ADDRESS"] = "MULTILINE_ADDRESS";
})(ValidationFormat || (ValidationFormat = {}));
export var ProductType;
(function (ProductType) {
    ProductType["UNKNOWN"] = "UNKNOWN";
    /** Shippable (physical). */
    ProductType["SHIPPABLE"] = "SHIPPABLE";
    /** Digital. */
    ProductType["DIGITAL"] = "DIGITAL";
})(ProductType || (ProductType = {}));
export var PriceType;
(function (PriceType) {
    PriceType["UNKNOWN"] = "UNKNOWN";
    /** Fixed price. */
    PriceType["FIXED_PRICE"] = "FIXED_PRICE";
    /** Dynamic price from price range. */
    PriceType["DYNAMIC_PRICE"] = "DYNAMIC_PRICE";
})(PriceType || (PriceType = {}));
export var FormatEnumFormat;
(function (FormatEnumFormat) {
    FormatEnumFormat["UNDEFINED"] = "UNDEFINED";
    FormatEnumFormat["DATE"] = "DATE";
    FormatEnumFormat["TIME"] = "TIME";
    FormatEnumFormat["DATE_TIME"] = "DATE_TIME";
    FormatEnumFormat["EMAIL"] = "EMAIL";
    FormatEnumFormat["URL"] = "URL";
    FormatEnumFormat["UUID"] = "UUID";
    FormatEnumFormat["PHONE"] = "PHONE";
    FormatEnumFormat["URI"] = "URI";
    FormatEnumFormat["HOSTNAME"] = "HOSTNAME";
    FormatEnumFormat["COLOR_HEX"] = "COLOR_HEX";
    FormatEnumFormat["CURRENCY"] = "CURRENCY";
    FormatEnumFormat["LANGUAGE"] = "LANGUAGE";
    FormatEnumFormat["DATE_OPTIONAL_TIME"] = "DATE_OPTIONAL_TIME";
})(FormatEnumFormat || (FormatEnumFormat = {}));
export var StringComponentType;
(function (StringComponentType) {
    StringComponentType["UNKNOWN"] = "UNKNOWN";
    StringComponentType["TEXT_INPUT"] = "TEXT_INPUT";
    StringComponentType["RADIO_GROUP"] = "RADIO_GROUP";
    StringComponentType["DROPDOWN"] = "DROPDOWN";
    StringComponentType["DATE_TIME"] = "DATE_TIME";
    StringComponentType["PHONE_INPUT"] = "PHONE_INPUT";
})(StringComponentType || (StringComponentType = {}));
export var NodeType;
(function (NodeType) {
    NodeType["PARAGRAPH"] = "PARAGRAPH";
    NodeType["TEXT"] = "TEXT";
    NodeType["HEADING"] = "HEADING";
    NodeType["BULLETED_LIST"] = "BULLETED_LIST";
    NodeType["ORDERED_LIST"] = "ORDERED_LIST";
    NodeType["LIST_ITEM"] = "LIST_ITEM";
    NodeType["BLOCKQUOTE"] = "BLOCKQUOTE";
    NodeType["CODE_BLOCK"] = "CODE_BLOCK";
    NodeType["VIDEO"] = "VIDEO";
    NodeType["DIVIDER"] = "DIVIDER";
    NodeType["FILE"] = "FILE";
    NodeType["GALLERY"] = "GALLERY";
    NodeType["GIF"] = "GIF";
    NodeType["HTML"] = "HTML";
    NodeType["IMAGE"] = "IMAGE";
    NodeType["LINK_PREVIEW"] = "LINK_PREVIEW";
    NodeType["MAP"] = "MAP";
    NodeType["POLL"] = "POLL";
    NodeType["APP_EMBED"] = "APP_EMBED";
    NodeType["BUTTON"] = "BUTTON";
    NodeType["COLLAPSIBLE_LIST"] = "COLLAPSIBLE_LIST";
    NodeType["TABLE"] = "TABLE";
    NodeType["EMBED"] = "EMBED";
    NodeType["COLLAPSIBLE_ITEM"] = "COLLAPSIBLE_ITEM";
    NodeType["COLLAPSIBLE_ITEM_TITLE"] = "COLLAPSIBLE_ITEM_TITLE";
    NodeType["COLLAPSIBLE_ITEM_BODY"] = "COLLAPSIBLE_ITEM_BODY";
    NodeType["TABLE_CELL"] = "TABLE_CELL";
    NodeType["TABLE_ROW"] = "TABLE_ROW";
    NodeType["EXTERNAL"] = "EXTERNAL";
    NodeType["AUDIO"] = "AUDIO";
})(NodeType || (NodeType = {}));
export var WidthType;
(function (WidthType) {
    /** Width matches the content width */
    WidthType["CONTENT"] = "CONTENT";
    /** Small Width */
    WidthType["SMALL"] = "SMALL";
    /** Width will match the original asset width */
    WidthType["ORIGINAL"] = "ORIGINAL";
    /** coast-to-coast display */
    WidthType["FULL_WIDTH"] = "FULL_WIDTH";
})(WidthType || (WidthType = {}));
export var PluginContainerDataAlignment;
(function (PluginContainerDataAlignment) {
    /** Center Alignment */
    PluginContainerDataAlignment["CENTER"] = "CENTER";
    /** Left Alignment */
    PluginContainerDataAlignment["LEFT"] = "LEFT";
    /** Right Alignment */
    PluginContainerDataAlignment["RIGHT"] = "RIGHT";
})(PluginContainerDataAlignment || (PluginContainerDataAlignment = {}));
export var Type;
(function (Type) {
    /** Regular link button */
    Type["LINK"] = "LINK";
    /** Triggers custom action that is defined in plugin configuration by the consumer */
    Type["ACTION"] = "ACTION";
})(Type || (Type = {}));
export var Target;
(function (Target) {
    /** Opens the linked document in the same frame as it was clicked (this is default) */
    Target["SELF"] = "SELF";
    /** Opens the linked document in a new window or tab */
    Target["BLANK"] = "BLANK";
    /** Opens the linked document in the parent frame */
    Target["PARENT"] = "PARENT";
    /** Opens the linked document in the full body of the window */
    Target["TOP"] = "TOP";
})(Target || (Target = {}));
export var TextAlignment;
(function (TextAlignment) {
    /** browser default, eqivalent to `initial` */
    TextAlignment["AUTO"] = "AUTO";
    /** Left align */
    TextAlignment["LEFT"] = "LEFT";
    /** Right align */
    TextAlignment["RIGHT"] = "RIGHT";
    /** Center align */
    TextAlignment["CENTER"] = "CENTER";
    /** Text is spaced to line up its left and right edges to the left and right edges of the line box, except for the last line */
    TextAlignment["JUSTIFY"] = "JUSTIFY";
})(TextAlignment || (TextAlignment = {}));
export var LineStyle;
(function (LineStyle) {
    /** Single Line */
    LineStyle["SINGLE"] = "SINGLE";
    /** Double Line */
    LineStyle["DOUBLE"] = "DOUBLE";
    /** Dashed Line */
    LineStyle["DASHED"] = "DASHED";
    /** Dotted Line */
    LineStyle["DOTTED"] = "DOTTED";
})(LineStyle || (LineStyle = {}));
export var Width;
(function (Width) {
    /** Large line */
    Width["LARGE"] = "LARGE";
    /** Medium line */
    Width["MEDIUM"] = "MEDIUM";
    /** Small line */
    Width["SMALL"] = "SMALL";
})(Width || (Width = {}));
export var Alignment;
(function (Alignment) {
    /** Center alignment */
    Alignment["CENTER"] = "CENTER";
    /** Left alignment */
    Alignment["LEFT"] = "LEFT";
    /** Right alignment */
    Alignment["RIGHT"] = "RIGHT";
})(Alignment || (Alignment = {}));
export var ViewMode;
(function (ViewMode) {
    /** No PDF view */
    ViewMode["NONE"] = "NONE";
    /** Full PDF view */
    ViewMode["FULL"] = "FULL";
    /** Mini PDF view */
    ViewMode["MINI"] = "MINI";
})(ViewMode || (ViewMode = {}));
export var LayoutType;
(function (LayoutType) {
    /** Collage type */
    LayoutType["COLLAGE"] = "COLLAGE";
    /** Masonry type */
    LayoutType["MASONRY"] = "MASONRY";
    /** Grid type */
    LayoutType["GRID"] = "GRID";
    /** Thumbnail type */
    LayoutType["THUMBNAIL"] = "THUMBNAIL";
    /** Slider type */
    LayoutType["SLIDER"] = "SLIDER";
    /** Slideshow type */
    LayoutType["SLIDESHOW"] = "SLIDESHOW";
    /** Panorama type */
    LayoutType["PANORAMA"] = "PANORAMA";
    /** Column type */
    LayoutType["COLUMN"] = "COLUMN";
    /** Magic type */
    LayoutType["MAGIC"] = "MAGIC";
    /** Fullsize images type */
    LayoutType["FULLSIZE"] = "FULLSIZE";
})(LayoutType || (LayoutType = {}));
export var Orientation;
(function (Orientation) {
    /** Rows Orientation */
    Orientation["ROWS"] = "ROWS";
    /** Columns Orientation */
    Orientation["COLUMNS"] = "COLUMNS";
})(Orientation || (Orientation = {}));
export var Crop;
(function (Crop) {
    /** Crop to fill */
    Crop["FILL"] = "FILL";
    /** Crop to fit */
    Crop["FIT"] = "FIT";
})(Crop || (Crop = {}));
export var ThumbnailsAlignment;
(function (ThumbnailsAlignment) {
    /** Top alignment */
    ThumbnailsAlignment["TOP"] = "TOP";
    /** Right alignment */
    ThumbnailsAlignment["RIGHT"] = "RIGHT";
    /** Bottom alignment */
    ThumbnailsAlignment["BOTTOM"] = "BOTTOM";
    /** Left alignment */
    ThumbnailsAlignment["LEFT"] = "LEFT";
    /** No thumbnail */
    ThumbnailsAlignment["NONE"] = "NONE";
})(ThumbnailsAlignment || (ThumbnailsAlignment = {}));
export var Source;
(function (Source) {
    Source["HTML"] = "HTML";
    Source["ADSENSE"] = "ADSENSE";
})(Source || (Source = {}));
export var MapType;
(function (MapType) {
    /** Roadmap map type */
    MapType["ROADMAP"] = "ROADMAP";
    /** Satellite map type */
    MapType["SATELITE"] = "SATELITE";
    /** Hybrid map type */
    MapType["HYBRID"] = "HYBRID";
    /** Terrain map type */
    MapType["TERRAIN"] = "TERRAIN";
})(MapType || (MapType = {}));
export var ViewRole;
(function (ViewRole) {
    /** Only Poll creator can view the results */
    ViewRole["CREATOR"] = "CREATOR";
    /** Anyone who voted can see the results */
    ViewRole["VOTERS"] = "VOTERS";
    /** Anyone can see the results, even if one didn't vote */
    ViewRole["EVERYONE"] = "EVERYONE";
})(ViewRole || (ViewRole = {}));
export var VoteRole;
(function (VoteRole) {
    /** Logged in member */
    VoteRole["SITE_MEMBERS"] = "SITE_MEMBERS";
    /** Anyone */
    VoteRole["ALL"] = "ALL";
})(VoteRole || (VoteRole = {}));
export var PollLayoutType;
(function (PollLayoutType) {
    /** List */
    PollLayoutType["LIST"] = "LIST";
    /** Grid */
    PollLayoutType["GRID"] = "GRID";
})(PollLayoutType || (PollLayoutType = {}));
export var PollLayoutDirection;
(function (PollLayoutDirection) {
    /** Left-to-right */
    PollLayoutDirection["LTR"] = "LTR";
    /** Right-to-left */
    PollLayoutDirection["RTL"] = "RTL";
})(PollLayoutDirection || (PollLayoutDirection = {}));
export var BackgroundType;
(function (BackgroundType) {
    /** Color background type */
    BackgroundType["COLOR"] = "COLOR";
    /** Image background type */
    BackgroundType["IMAGE"] = "IMAGE";
    /** Gradiant background type */
    BackgroundType["GRADIENT"] = "GRADIENT";
})(BackgroundType || (BackgroundType = {}));
export var DecorationType;
(function (DecorationType) {
    DecorationType["BOLD"] = "BOLD";
    DecorationType["ITALIC"] = "ITALIC";
    DecorationType["UNDERLINE"] = "UNDERLINE";
    DecorationType["SPOILER"] = "SPOILER";
    DecorationType["ANCHOR"] = "ANCHOR";
    DecorationType["MENTION"] = "MENTION";
    DecorationType["LINK"] = "LINK";
    DecorationType["COLOR"] = "COLOR";
    DecorationType["FONT_SIZE"] = "FONT_SIZE";
    DecorationType["EXTERNAL"] = "EXTERNAL";
})(DecorationType || (DecorationType = {}));
export var FontType;
(function (FontType) {
    FontType["PX"] = "PX";
    FontType["EM"] = "EM";
})(FontType || (FontType = {}));
export var AppType;
(function (AppType) {
    AppType["PRODUCT"] = "PRODUCT";
    AppType["EVENT"] = "EVENT";
    AppType["BOOKING"] = "BOOKING";
})(AppType || (AppType = {}));
export var InitialExpandedItems;
(function (InitialExpandedItems) {
    /** First item will be expended initally */
    InitialExpandedItems["FIRST"] = "FIRST";
    /** All items will expended initally */
    InitialExpandedItems["ALL"] = "ALL";
    /** All items collapsed initally */
    InitialExpandedItems["NONE"] = "NONE";
})(InitialExpandedItems || (InitialExpandedItems = {}));
export var Direction;
(function (Direction) {
    /** Left-to-right */
    Direction["LTR"] = "LTR";
    /** Right-to-left */
    Direction["RTL"] = "RTL";
})(Direction || (Direction = {}));
export var VerticalAlignment;
(function (VerticalAlignment) {
    /** Top alignment */
    VerticalAlignment["TOP"] = "TOP";
    /** Middle alignment */
    VerticalAlignment["MIDDLE"] = "MIDDLE";
    /** Bottom alignment */
    VerticalAlignment["BOTTOM"] = "BOTTOM";
})(VerticalAlignment || (VerticalAlignment = {}));
/**
 * `NullValue` is a singleton enumeration to represent the null value for the
 * `Value` type union.
 *
 * The JSON representation for `NullValue` is JSON `null`.
 */
export var NullValue;
(function (NullValue) {
    /** Null value. */
    NullValue["NULL_VALUE"] = "NULL_VALUE";
})(NullValue || (NullValue = {}));
export var DateFormatPart;
(function (DateFormatPart) {
    DateFormatPart["YEAR"] = "YEAR";
    DateFormatPart["MONTH"] = "MONTH";
    DateFormatPart["DAY"] = "DAY";
})(DateFormatPart || (DateFormatPart = {}));
export var FirstDayOfWeek;
(function (FirstDayOfWeek) {
    FirstDayOfWeek["MONDAY"] = "MONDAY";
    FirstDayOfWeek["SUNDAY"] = "SUNDAY";
})(FirstDayOfWeek || (FirstDayOfWeek = {}));
export var DateTimeInputType;
(function (DateTimeInputType) {
    DateTimeInputType["UNKNOWN"] = "UNKNOWN";
    /** Show date and time input */
    DateTimeInputType["DATE_TIME"] = "DATE_TIME";
    /** Show only date input */
    DateTimeInputType["DATE"] = "DATE";
    /** Show only time input */
    DateTimeInputType["TIME"] = "TIME";
    /** Show date picker input */
    DateTimeInputType["DATE_PICKER"] = "DATE_PICKER";
})(DateTimeInputType || (DateTimeInputType = {}));
export var NumberComponentType;
(function (NumberComponentType) {
    NumberComponentType["UNKNOWN"] = "UNKNOWN";
    NumberComponentType["NUMBER_INPUT"] = "NUMBER_INPUT";
    NumberComponentType["RATING_INPUT"] = "RATING_INPUT";
})(NumberComponentType || (NumberComponentType = {}));
export var BooleanComponentType;
(function (BooleanComponentType) {
    BooleanComponentType["UNKNOWN"] = "UNKNOWN";
    BooleanComponentType["CHECKBOX"] = "CHECKBOX";
})(BooleanComponentType || (BooleanComponentType = {}));
export var ItemType;
(function (ItemType) {
    ItemType["UNKNOWN"] = "UNKNOWN";
    ItemType["STRING"] = "STRING";
    ItemType["NUMBER"] = "NUMBER";
    ItemType["BOOLEAN"] = "BOOLEAN";
    ItemType["INTEGER"] = "INTEGER";
    ItemType["OBJECT"] = "OBJECT";
})(ItemType || (ItemType = {}));
export var PropertiesTypePropertiesType;
(function (PropertiesTypePropertiesType) {
    PropertiesTypePropertiesType["UNKNOWN"] = "UNKNOWN";
    PropertiesTypePropertiesType["STRING"] = "STRING";
    PropertiesTypePropertiesType["NUMBER"] = "NUMBER";
    PropertiesTypePropertiesType["BOOLEAN"] = "BOOLEAN";
    PropertiesTypePropertiesType["INTEGER"] = "INTEGER";
    PropertiesTypePropertiesType["ARRAY"] = "ARRAY";
})(PropertiesTypePropertiesType || (PropertiesTypePropertiesType = {}));
export var ComponentType;
(function (ComponentType) {
    ComponentType["UNKNOWN"] = "UNKNOWN";
    ComponentType["CHECKBOX_GROUP"] = "CHECKBOX_GROUP";
})(ComponentType || (ComponentType = {}));
export var WixFileComponentType;
(function (WixFileComponentType) {
    WixFileComponentType["UNKNOWN"] = "UNKNOWN";
    WixFileComponentType["FILE_UPLOAD"] = "FILE_UPLOAD";
    WixFileComponentType["SIGNATURE"] = "SIGNATURE";
})(WixFileComponentType || (WixFileComponentType = {}));
export var UploadFileFormat;
(function (UploadFileFormat) {
    UploadFileFormat["UNDEFINED"] = "UNDEFINED";
    /** Video files */
    UploadFileFormat["VIDEO"] = "VIDEO";
    /** Image files */
    UploadFileFormat["IMAGE"] = "IMAGE";
    /** Audio files */
    UploadFileFormat["AUDIO"] = "AUDIO";
    /** Document files */
    UploadFileFormat["DOCUMENT"] = "DOCUMENT";
})(UploadFileFormat || (UploadFileFormat = {}));
export var PaymentComponentType;
(function (PaymentComponentType) {
    PaymentComponentType["UNKNOWN"] = "UNKNOWN";
    PaymentComponentType["CHECKBOX_GROUP"] = "CHECKBOX_GROUP";
    PaymentComponentType["DONATION_INPUT"] = "DONATION_INPUT";
})(PaymentComponentType || (PaymentComponentType = {}));
export var NumberOfColumns;
(function (NumberOfColumns) {
    NumberOfColumns["UNKNOWN"] = "UNKNOWN";
    NumberOfColumns["ONE"] = "ONE";
    NumberOfColumns["TWO"] = "TWO";
    NumberOfColumns["THREE"] = "THREE";
})(NumberOfColumns || (NumberOfColumns = {}));
export var MultilineAddressComponentType;
(function (MultilineAddressComponentType) {
    MultilineAddressComponentType["UNKNOWN"] = "UNKNOWN";
    MultilineAddressComponentType["MULTILINE_ADDRESS"] = "MULTILINE_ADDRESS";
})(MultilineAddressComponentType || (MultilineAddressComponentType = {}));
export var DefaultCountryConfigType;
(function (DefaultCountryConfigType) {
    DefaultCountryConfigType["UNKNOWN_DEFAULT_COUNTRY"] = "UNKNOWN_DEFAULT_COUNTRY";
    /** Country will be determined by customer's IP address. */
    DefaultCountryConfigType["BY_IP"] = "BY_IP";
    /** Pre-selected default country. */
    DefaultCountryConfigType["COUNTRY"] = "COUNTRY";
})(DefaultCountryConfigType || (DefaultCountryConfigType = {}));
export var InputType;
(function (InputType) {
    InputType["UNKNOWN"] = "UNKNOWN";
    InputType["STRING"] = "STRING";
    InputType["NUMBER"] = "NUMBER";
    InputType["BOOLEAN"] = "BOOLEAN";
    InputType["ARRAY"] = "ARRAY";
    InputType["OBJECT"] = "OBJECT";
    InputType["WIX_FILE"] = "WIX_FILE";
    InputType["PAYMENT"] = "PAYMENT";
    InputType["MULTILINE_ADDRESS"] = "MULTILINE_ADDRESS";
})(InputType || (InputType = {}));
export var TargetEnumTarget;
(function (TargetEnumTarget) {
    TargetEnumTarget["UNDEFINED"] = "UNDEFINED";
    /** Opened in same browser tab */
    TargetEnumTarget["SELF"] = "SELF";
    /** Url open in new tab */
    TargetEnumTarget["BLANK"] = "BLANK";
})(TargetEnumTarget || (TargetEnumTarget = {}));
export var FieldType;
(function (FieldType) {
    FieldType["UNKNOWN"] = "UNKNOWN";
    FieldType["INPUT"] = "INPUT";
    FieldType["DISPLAY"] = "DISPLAY";
    FieldType["SUBMIT"] = "SUBMIT";
})(FieldType || (FieldType = {}));
export var EmailInfoTag;
(function (EmailInfoTag) {
    EmailInfoTag["UNTAGGED"] = "UNTAGGED";
    EmailInfoTag["MAIN"] = "MAIN";
})(EmailInfoTag || (EmailInfoTag = {}));
export var PhoneInfoTag;
(function (PhoneInfoTag) {
    PhoneInfoTag["UNTAGGED"] = "UNTAGGED";
    PhoneInfoTag["MAIN"] = "MAIN";
})(PhoneInfoTag || (PhoneInfoTag = {}));
export var Tag;
(function (Tag) {
    Tag["UNTAGGED"] = "UNTAGGED";
    Tag["HOME"] = "HOME";
})(Tag || (Tag = {}));
export var OptInLevel;
(function (OptInLevel) {
    OptInLevel["UNKNOWN"] = "UNKNOWN";
    OptInLevel["SINGLE_CONFIRMATION"] = "SINGLE_CONFIRMATION";
    OptInLevel["DOUBLE_CONFIRMATION"] = "DOUBLE_CONFIRMATION";
})(OptInLevel || (OptInLevel = {}));
export var ContactField;
(function (ContactField) {
    ContactField["UNDEFINED"] = "UNDEFINED";
    ContactField["FIRST_NAME"] = "FIRST_NAME";
    ContactField["LAST_NAME"] = "LAST_NAME";
    ContactField["COMPANY"] = "COMPANY";
    ContactField["POSITION"] = "POSITION";
    ContactField["EMAIL"] = "EMAIL";
    ContactField["PHONE"] = "PHONE";
    ContactField["ADDRESS"] = "ADDRESS";
    ContactField["BIRTHDATE"] = "BIRTHDATE";
    ContactField["CUSTOM_FIELD"] = "CUSTOM_FIELD";
    ContactField["SUBSCRIPTION"] = "SUBSCRIPTION";
    ContactField["VAT_ID"] = "VAT_ID";
})(ContactField || (ContactField = {}));
export var OverrideEntityType;
(function (OverrideEntityType) {
    OverrideEntityType["UNKNOWN"] = "UNKNOWN";
    OverrideEntityType["FIELD"] = "FIELD";
    OverrideEntityType["FORM"] = "FORM";
    OverrideEntityType["NESTED_FORM_FIELD"] = "NESTED_FORM_FIELD";
})(OverrideEntityType || (OverrideEntityType = {}));
export var Kind;
(function (Kind) {
    Kind["REGULAR"] = "REGULAR";
    Kind["EXTENSION"] = "EXTENSION";
})(Kind || (Kind = {}));
export var SpamFilterProtectionLevel;
(function (SpamFilterProtectionLevel) {
    SpamFilterProtectionLevel["UNKNOWN"] = "UNKNOWN";
    /** Spam filter is not used. Form is open for spam submissions. */
    SpamFilterProtectionLevel["NONE"] = "NONE";
    /** Spam filter operates in basic mode. Form is open to high risk of spam submissions. */
    SpamFilterProtectionLevel["BASIC"] = "BASIC";
    /** Spam filter operates in advanced mode. Form is open to low risk of spam submissions. */
    SpamFilterProtectionLevel["ADVANCED"] = "ADVANCED";
})(SpamFilterProtectionLevel || (SpamFilterProtectionLevel = {}));
export var ValidationMode;
(function (ValidationMode) {
    ValidationMode["UNKNOWN"] = "UNKNOWN";
    ValidationMode["UNRESTRICTED_UPDATE"] = "UNRESTRICTED_UPDATE";
})(ValidationMode || (ValidationMode = {}));
export var Feature;
(function (Feature) {
    Feature["UNKNOWN_FEATURE"] = "UNKNOWN_FEATURE";
    Feature["FILE_UPLOAD_FIELD"] = "FILE_UPLOAD_FIELD";
    Feature["ACCEPT_PAYMENTS"] = "ACCEPT_PAYMENTS";
    Feature["REMOVE_WIX_BRANDING"] = "REMOVE_WIX_BRANDING";
    Feature["SIGNATURE_FIELD"] = "SIGNATURE_FIELD";
    Feature["FILE_DOWNLOAD"] = "FILE_DOWNLOAD";
})(Feature || (Feature = {}));
export var AscendPlan;
(function (AscendPlan) {
    AscendPlan["NOT_ASCEND"] = "NOT_ASCEND";
    AscendPlan["FREE"] = "FREE";
    AscendPlan["BASIC"] = "BASIC";
    AscendPlan["PROFESSIONAL"] = "PROFESSIONAL";
    AscendPlan["UNLIMITED"] = "UNLIMITED";
})(AscendPlan || (AscendPlan = {}));
export var ActionType;
(function (ActionType) {
    ActionType["UNKNOWN_ACTION"] = "UNKNOWN_ACTION";
    ActionType["UPDATE"] = "UPDATE";
    ActionType["CREATE"] = "CREATE";
})(ActionType || (ActionType = {}));
//# sourceMappingURL=types.impl.js.map